import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";

const selectEntities = (state: RootState) =>
  state.data.equipmentDepots.entities;
const selectIds = (state: RootState) => state.data.equipmentDepots.ids;

export const selectEquipmentDepots = createSelector(
  selectIds,
  selectEntities,
  (ids, entities) => ids.map((id) => entities[id])
);

export const selectEquipmentDepot =
  (id?: string | null) => (state: RootState) =>
    !id ? undefined : state.data.equipmentDepots.entities[id];

export const selectEquipmentDepotArchiveErrors = (state: RootState) =>
  state.data.equipmentDepots.archiveErrors;

export const selectEquipmentDepotsLoading = (state: RootState) =>
  state.data.equipmentDepots.loading;
